<template>
  <div
    class="fixed top-[36px] sm:top-[38px] left-0 right-0 bg-[var(--color-8)] dark:bg-transparent dark:bg-[linear-gradient(287.24deg,#1F0432_2.25%,#1D0231_93.17%)] z-50 border-b border-t border-[#8a36c2]"
  >
    <Menubar
      unstyled
      :pt="{
        root: {
          class:
            'text-[var(--secondary-foreground)] relative py-3 lg:py-5 border-0 bg-transparent max-w-screen-xl px-4 mx-auto border-[#250243] flex items-center justify-between',
        },
        start: { class: 'flex items-center' },
        end: { class: 'ml-auto flex items-center' },
      }"
    >
      <template #start>
        <NuxtLink
          to="/"
          aria-label="wri-logo"
          class="flex items-center text-3xl"
        >
          <video autoplay loop muted playsinline width="50" height="39">
            <source src="/images/WRI-logo2.webm" type="video/webm" />
          </video>
          <span v-if="isDesktop">
            <span class="border-l pl-2 border-[#B88ABE50] mt-1 font-semibold">
              web</span
            >reinvent
          </span>
        </NuxtLink>
      </template>

      <template #end>
        <WrSecondNavItems />
      </template>
    </Menubar>
  </div>
</template>
<script setup>
const { isDesktop } = useDevice();
</script>
